export enum CommonShortcutType {
  TableCellCatchAll = 'table-cell-catch-all',
  InputFieldCatchAll = 'input-field-catch-all',
  TableCellEditCommit = 'table-cell-edit-commit',
  SuggestionPicker = 'suggestion-picker',
}
